import { useEffect, useState, lazy, Suspense } from "react";
import { ReactLenis, useLenis } from "lenis/react";
import { Toaster } from "sonner";
import "@/App.css";

import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
// import About from "@/components/About";
import ExperienceElla from "@/components/ExperienceElla";
import ExperienceEl from "@/components/ExperienceEl";
import DuoExperiences from "@/components/DuoExperiences";
import Testimonials from "@/components/Testimonials";
import BookingCTA from "@/components/BookingCTA";
import SiteFooter from "@/components/SiteFooter";
import BookingModal from "@/components/BookingModal";
import { Loader2 } from "lucide-react";
import WhatsAppFloatingButton from "@/components/WhatsAppFloatingButton";

const AdminPanel = lazy(() => import("@/components/AdminPanel"));
const AdminLogin = lazy(() => import("@/components/AdminLogin"));

function LenisBridge() {
  const lenis = useLenis();
  useEffect(() => {
    window.__lenis = lenis;
  }, [lenis]);
  return null;
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [adminUser, setAdminUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);

  const isAdmin = typeof window !== "undefined" && new URLSearchParams(window.location.search).has("admin");

  useEffect(() => {
    document.title = "DUO Experience · Spa de lujo unisex · Bogotá";
  }, []);

  useEffect(() => {
    if (isAdmin) {
      fetch("/api/admin_me.php")
        .then((res) => res.json())
        .then((data) => {
          if (data.authenticated) {
            setIsAuthenticated(true);
            setAdminUser(data.admin);
          }
          setAuthChecked(true);
        })
        .catch(() => {
          setAuthChecked(true);
        });
    }
  }, [isAdmin]);

  if (isAdmin) {
    if (!authChecked) {
      return (
        <div className="min-h-screen bg-[#1a1a1a] flex items-center justify-center text-white">
          <Loader2 className="h-8 w-8 animate-spin text-[#cea498]" />
        </div>
      );
    }

    return (
      <div className="App bg-[#faf9f6]">
        <Suspense
          fallback={
            <div className="min-h-screen bg-[#1a1a1a] flex items-center justify-center text-white">
              <Loader2 className="h-8 w-8 animate-spin text-[#cea498]" />
            </div>
          }
        >
          {isAuthenticated ? (
            <AdminPanel admin={adminUser} onLogout={() => {
              setIsAuthenticated(false);
              setAdminUser(null);
            }} />
          ) : (
            <AdminLogin onLoginSuccess={(admin) => {
              setIsAuthenticated(true);
              setAdminUser(admin);
            }} />
          )}
        </Suspense>
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#3a3939",
              color: "#faf9f6",
              border: "1px solid rgba(143,165,138,0.4)",
              fontFamily: "Montserrat, sans-serif",
            },
          }}
        />
      </div>
    );
  }

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <LenisBridge />
      <div className="App">
        <Navbar />
        <main>
          <Hero />
          <ExperienceElla />
          <ExperienceEl />
          <DuoExperiences />
          <Testimonials />
          <BookingCTA />
        </main>
        <SiteFooter />
        <BookingModal />
        <WhatsAppFloatingButton />
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#3a3939",
              color: "#faf9f6",
              border: "1px solid rgba(143,165,138,0.4)",
              fontFamily: "Montserrat, sans-serif",
            },
          }}
        />
      </div>
    </ReactLenis>
  );
}

export default App;
